(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('UserActivation', UserActivation);

    UserActivation.$inject = ['$resource', 'DateUtils'];

    function UserActivation ($resource, DateUtils) {
        var resourceUrl =  'api/user-activations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastSyncTime = DateUtils.convertDateTimeFromServer(data.lastSyncTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
